import { FC } from 'react';
import cancellationSectionModal from '../../assets/scss/TermsOfServiceModal/CancellationSectionModal.module.scss';
import {
  CancellationWayDataType,
  useCancellationWayData,
} from '../../hooks/use-cancellation-way-data';
import pauseRecommend from '../../assets/images/pause_recommend.png';
import pauseWay from '../../assets/images/pause_way.png';
import { CommonModal } from '../CommonModal';
import { postMessageGtag } from '../../utils/trackClick';

type CancellationSectionModalProps = {
  active: boolean;
  closeFunc: () => void;
  clickSkipFunc: () => void;
};

export const CancellationSectionModal: FC<CancellationSectionModalProps> = ({
  active,
  closeFunc,
  clickSkipFunc,
}) => {
  const { cancellationWayList } = useCancellationWayData();

  if (!active) return null;

  const content = (
    <div className={cancellationSectionModal.container}>
      <p className={cancellationSectionModal.title}>定期便のお届けを止めるには？</p>
      <p style={{ marginTop: '32px' }}>
        定期便のお届けを止める方法は
        <span className={cancellationSectionModal.boldText}>「停止」</span>と
        <span className={cancellationSectionModal.boldText}>「解約」</span>の2種類あります。
      </p>

      {/* 停止 */}
      <StopSection clickSkipFunc={clickSkipFunc} />
      {/* 解約 */}
      <CancelSection cancellationWayList={cancellationWayList} />

      <div
        className={cancellationSectionModal.divider}
        style={{ marginTop: '40px', paddingTop: '64px', textAlign: 'center' }}
      >
        <button onClick={closeFunc}>閉じる</button>
      </div>
    </div>
  );

  return (
    <CommonModal
      active={active}
      closeFunc={closeFunc}
    >
      {content}
    </CommonModal>
  );
};

const StopSection: FC<{ clickSkipFunc: () => void }> = ({ clickSkipFunc }) => {
  return (
    <div
      className={cancellationSectionModal.divider}
      style={{ marginTop: '32px', paddingTop: '24px' }}
    >
      <p className={cancellationSectionModal.itemTitle}>停止</p>
      <p className={cancellationSectionModal.itemText}>定期オトク便を、一時的にお休みできます。</p>

      <div className={cancellationSectionModal.recommendTitle}>こんなあなたにおすすめ！</div>

      <div style={{ marginTop: '16px' }}>
        <img
          className={cancellationSectionModal.img}
          src={pauseRecommend}
          alt=""
        />
      </div>

      <div className={cancellationSectionModal.recommendContainer}>
        <RecommendText text="食べきれない、少し余っている" />
        <RecommendText text="まとめて購入したので今月はお休みしたい" />
        <RecommendText text="お届けを止めたいけれど、再開するかもしれない" />
      </div>
      <p className={cancellationSectionModal.itemText}>
        停止はお届け先情報・各種設定が残るので
        <span className={cancellationSectionModal.boldText}>簡単に再開できます！</span>
      </p>

      <p
        className={cancellationSectionModal.itemTitle}
        style={{ marginTop: '40px' }}
      >
        停止のやり方
      </p>
      <p className={cancellationSectionModal.itemText}>
        定期オトク便ページの下部にある「お届けを止める」をクリックし、「定期オトク便を停止する」から停止することができます。
      </p>
      <div style={{ marginTop: '24px' }}>
        <img
          className={cancellationSectionModal.img}
          src={pauseWay}
          alt=""
        />
      </div>

      <div className={cancellationSectionModal.skipContainer}>
        <p>
          今月だけお休みしたい...
          <br />
          <span className={cancellationSectionModal.skipHighlight}>
            そんなあなたにはスキップがおすすめ！
          </span>
        </p>
        <p style={{ marginTop: '16px' }}>
          お届け日を2週間後・4週間後に
          <br />
          カンタンに変更できます
        </p>
        <div style={{ marginTop: '22px' }}>
          <button
            className={cancellationSectionModal.btnSkip}
            onClick={() => {
              clickSkipFunc();
              postMessageGtag('click_howtoPauseCancel_Skip', 'detailContract');
            }}
          >
            スキップする
          </button>
        </div>
      </div>
    </div>
  );
};

const CancelSection: FC<{ cancellationWayList: CancellationWayDataType[] }> = ({
  cancellationWayList,
}) => {
  return (
    <div
      className={cancellationSectionModal.divider}
      style={{ marginTop: '40px', paddingTop: '40px' }}
    >
      <p className={cancellationSectionModal.itemTitle}>解約</p>
      <p className={cancellationSectionModal.itemText}>
        定期オトク便を解約します。
        <br />
        <span className={cancellationSectionModal.boldText}>
          解約前の情報を引き継ぐことができません。
        </span>
      </p>

      {cancellationWayList.length !== 0 && (
        <p
          className={cancellationSectionModal.itemTitle}
          style={{ marginTop: '40px' }}
        >
          解約のやり方
        </p>
      )}

      {cancellationWayList.map((item, index) => (
        <div
          key={index}
          className={cancellationSectionModal.wayContainer}
        >
          <div dangerouslySetInnerHTML={{ __html: item.text }} />
          {item.image && (
            <img
              src={item.image}
              alt=""
            />
          )}
        </div>
      ))}
    </div>
  );
};

type RecommendTextProps = {
  text: string;
};

function RecommendText({ text }: RecommendTextProps) {
  return (
    <div className={cancellationSectionModal.recommendItem}>
      <div className={cancellationSectionModal.circle} />
      <span className={cancellationSectionModal.label}>{text}</span>
    </div>
  );
}
